export enum ArchivesColumns {
  ID = "id",
  DATE_FROM = "date_from",
  DATE_TO = "date_to",
  FILENAME = "filename",
  STATUS = "status",
  CREATED_AT = "created_at",
  ACTIONS = "actions",
}

export const all = Object.keys(ArchivesColumns).filter((item) => {
  return isNaN(Number(item));
});
